import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AuthserviceService } from '../../../core/services/authservice.service';
import { LoginResponse } from '../../../core/models/users';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { initFlowbite } from 'flowbite';
import { SolicitudesService } from '../../../core/services/solicitudes.service';

@Component({
    selector: 'app-sidenav',
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgxSpinnerModule,
        ToggleSwitchModule
    ],
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() collapsed = false;
  @Output() closed = new EventEmitter<void>();

  isDarkMode = false;

  openSections: Record<string, boolean> = {
    administracion: false,
    farmaia: false,
    automatismos: false,
    comunicaciones: false,
    debug: false,
  };

  toggleSection(section: keyof typeof this.openSections) {
    this.openSections[section] = !this.openSections[section];
  }

  isSectionOpen(section: keyof typeof this.openSections): boolean {
    return this.openSections[section];
  }

  User: LoginResponse | undefined;
  readonly spinnerName = 'sidenavSpinner';
  pendientesCount = 0;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private authservice: AuthserviceService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private solicitudesService: SolicitudesService
  ) {
    this.User = this.authservice.usuarioValue;
  }

  ngOnInit(): void {
    const stored = localStorage.getItem('dark-mode');
    this.isDarkMode = stored === 'true';
    this.updateBodyClass();
    this.cargarPendientes();
    this.solicitudesService.pendientesRefresh$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cargarPendientes());
  }

  ngAfterViewInit(): void {
    initFlowbite();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get esAdmin(): boolean {
    return this.authservice.usuarioValue?.rol === 1;
  }

  private cargarPendientes(): void {
    this.solicitudesService.obtenerListadoSolicitudes()
      .subscribe({
        next: (response) => {
          const items = (response as any)?.items ?? (response as any)?.datos ?? [];
          if (!Array.isArray(items)) {
            this.pendientesCount = 0;
            return;
          }
          this.pendientesCount = items.filter((item) => {
            const estado = (item?.estado ?? '').toUpperCase();
            return estado === 'PENDIENTE';
          }).length;
        },
        error: () => {
          this.pendientesCount = 0;
        }
      });
  }

  navigateTo(route: string): void {
    this.spinner.show(this.spinnerName);
    this.router.navigate([route])
      .finally(() => this.spinner.hide(this.spinnerName));
  }

  closeMobileSidenav(): void {
    if (typeof window === 'undefined') return;
    if (!window.matchMedia('(max-width: 639px)').matches) return;
    const sidebar = document.getElementById('default-sidebar');
    if (!sidebar) return;
    this.renderer.addClass(sidebar, '-translate-x-full');
    this.renderer.removeClass(sidebar, 'translate-x-0');
    this.closed.emit();
  }

  logout() {
    this.spinner.show(this.spinnerName);
    this.authservice.logout();
    setTimeout(() => this.spinner.hide(this.spinnerName), 1500);
  }

  onDarkModeChange(value: boolean) {
    this.isDarkMode = value;
    localStorage.setItem('dark-mode', String(value));
    this.updateBodyClass();
  }

  private updateBodyClass() {
    if (this.isDarkMode) {
      this.renderer.addClass(document.body, 'dark');
    } else {
      this.renderer.removeClass(document.body, 'dark');
    }
  }
}
